<div class="profile-members">
  <!-- ── Tags ── -->
  <div class="members-section">
    <div class="members-section-header">
      <span class="mds-label-strong mds-neutral--default__on-background-color">Tags</span>
    </div>

    <div class="tags-row">
      @for (tag of tagList; track tag) {
        <mc-tag [label]="tag" appearance="neutral" [withaction]="!readonly" (dismiss)="removeTag(tag)"></mc-tag>
      } @empty {
        <span class="empty-hint mds-body-small mds-neutral--default__on-background-color">No tags</span>
      }
    </div>

    @if (!readonly) {
      <div class="add-row">
        <mc-input
          fit="small"
          hiddenlabel
          placeholder="Add tag"
          [value]="newTagInput"
          (input)="onNewTagInput($event)"
          (keydown)="onNewTagKeydown($event)"></mc-input>
        <mc-button
          fit="small"
          label="Add"
          appearance="primary"
          variant="outlined"
          icon="plus"
          [disabled]="!newTagInput.trim()"
          (click)="addTag()"
          (keydown.enter)="addTag()"></mc-button>
      </div>
    }
  </div>

  <!-- ── Vendor Codes ── -->
  <div class="members-section">
    <div class="members-section-header">
      <span class="mds-label-strong mds-neutral--default__on-background-color">Vendor Codes</span>
      <span class="count-badge">{{ vendorList.length }}</span>
      <mc-input
        fit="small"
        placeholder="Search vendor"
        variant="vanity"
        clearbutton
        hiddenlabel
        [value]="vendorSearch"
        (input)="onVendorSearchInput($event)"
        (clearbuttonclick)="onVendorSearchClear()"></mc-input>
    </div>

    <div class="vendor-tags-container">
      @for (code of filteredVendors; track code) {
        <mc-tag [label]="code" appearance="neutral" [withaction]="!readonly" (dismiss)="removeVendor(code)"></mc-tag>
      } @empty {
        <span class="empty-hint mds-body-small mds-neutral--default__on-background-color">
          {{ vendorSearch ? 'No vendor codes match your search.' : 'No vendor codes.' }}
        </span>
      }
    </div>

    @if (!readonly) {
      <div>
        <!-- Pick at any geography level; the shops it resolves to drop into the field below, where
             they can still be edited or combined with codes typed by hand. -->
        <div class="geo-picker">
          <app-aems-geo-filter
            label="Add by region/cluster/country/location/shop"
            placeholder="Search region, cluster, country, location or shop"
            hint="Selected shop codes are filled into the field below."
            [(selection)]="geoSelection"
            (shopCodesChange)="onGeoShopCodesChange($event)"></app-aems-geo-filter>
        </div>

        <app-aems-multiline-tag-input
          [(ngModel)]="pendingVendorCodes"
          style="width: 100%"
          [regex]="vendorCodeRegex"
          [allowDuplicates]="false"
          placeholder="Add vendor code(s)"
          [transformToUppercase]="true">
        </app-aems-multiline-tag-input>
        <div class="m-t-4">
          <mc-button
            fit="small"
            label="Add"
            appearance="primary"
            variant="outlined"
            icon="plus"
            [disabled]="!pendingVendorCodes.length"
            (click)="addVendors()"
            (keydown.enter)="addVendors()"></mc-button>
        </div>
      </div>
    }
  </div>
</div>
